// extracted by mini-css-extract-plugin
export var content = "Text-module--content--f9704";
export var faq = "Text-module--faq--8adfc";
export var heading1 = "Text-module--heading1--8de15";
export var heading2 = "Text-module--heading2--42966";
export var heading3 = "Text-module--heading3--d2f36";
export var heading4 = "Text-module--heading4--a81af";
export var heading5 = "Text-module--heading5--5f683";
export var heading6 = "Text-module--heading6--f9bf7";
export var image = "Text-module--image--f4782";
export var intro = "Text-module--intro--41825";